<template>
    <div class="testpages">
            <model-viewer  @loaded="handleLoaded()" :folder="model3D"></model-viewer>
    </div>
</template>

<script>
    import ModelViewer from '../components/3D/ModelViewer.vue'
    export default {
        components:{
            ModelViewer
        },
        data(){
            return{
                ifShowIframe:false,
                model3D:'',
            }
        },
        methods:{
            handleLoaded(){
                scene.moSpecial.cameraSettings({ left: 120, right:120, up: 80, down: 80, in: 0, out:0});
            },
            randomFolder(){
                this.model='14HzK7e0le1n94165e52Hk3sxv1R2Oxk'
                return '14HzK7e0le1n94165e52Hk3sxv1R2Oxk'
            },
            handle(){
                this.ifShowIframe = true;
                this.randomFolder()
            }
        },
        mounted(){
            this.handle()
            this.model3D=this.$route.query.model3D
        }
    }
</script>

<style lang="less">

</style>


// WEBPACK FOOTER //
// src/views/webglTest.vue